import type { IconSvgObject } from './types';

const WifiDisconnected01Icon: IconSvgObject = [
  ["path", { d: "M8.5 15.9996C9.36651 15.1331 10.4207 14.6157 11.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.5 12.5C8.67327 9.32673 12.6221 8.67087 16 10.5324", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 8.5C8.31579 3.16669 15.6842 3.16668 22 8.49989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.0002 13.5L15.0002 19.5M21.0002 19.5L15.0002 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default WifiDisconnected01Icon;
